import React, {useContext, useState} from 'react';
import './EmailReceipt.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Input} from 'elements/input/Input';
import {Button} from "elements/button/Button";
import {Consent} from "compositions/consent/Consent";
import {ConsentText} from "elements/consent-text/ConsentText";
import {Error} from "elements/error/Error";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {CustomerType} from "reducers/customer.reducer.types";

export const EMAIL_RECEIPT_POPUP = 'EMAIL_RECEIPT_POPUP';//TODO don't show Subscribe
export const EMAIL_ALL_RECEIPTS_POPUP = 'EMAIL_ALL_RECEIPTS_POPUP';

export const EmailReceipt = ({currentCustomer,title, defaultEmail = '', error, defaultSubscribe = false, onOverlayClick, onCancelClick, onDoneClick}) => {
	const [email, setEmail] = useState(defaultEmail);
	const [isSubscribe, setIsSubscribe] = useState((currentCustomer?.phone && currentCustomer?.nickname) ? defaultSubscribe : false);

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={title}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('EmailReceiptPopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button isAutoWidth onClick={() => {
			onDoneClick(email, isSubscribe);
		}}>{
			getSafeTranslation('EmailReceiptPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="email-receipt">
			<div className="email-receipt__address-input">
				<Input
					value={email}
					onChange={setEmail}
					placeholder={getSafeTranslation('EmailReceiptPopup.inputPlaceholder', translations)}
					focusOnMount
				/>
			</div>
			{
				(currentCustomer?.phone && currentCustomer?.nickname && currentCustomer.type === CustomerType.REGISTERED)&& (
					<div className="email-receipt__subscribe" onClick={() => setIsSubscribe(!isSubscribe)}>
						<Consent
							isChecked={isSubscribe}
							caption={<ConsentText
								text={getSafeTranslation('EmailReceiptPopup.subscribeConsentCheckboxCaption', translations)}/>}
						/>
					</div>
				)
			}

			{
				error && (
					<div className="email-receipt__error">
						<Error text={error}/>
					</div>
				)
			}

		</div>
	</DrawerPopup>
}

